/**
 * product-quiz.js  —  assets/product-quiz.js
 *
 * Flujo:
 *   Paso 1 — Objetivo principal (selección única)
 *   Paso 2 — Objetivos adicionales (multi-select, opcional)
 *   Paso 3 — Género (selección única)
 *   Paso 4 — Detalle (dinámico según objetivo principal)
 *   Loader — GIF + código de descuento (copiar para continuar)
 *   Resultado — Producto principal + bundle de objetivos adicionales
 *
 * Tags requeridos en productos:
 *   quiz-objetivo-[rendimiento|mental|sueno|digestion|peso|inmunidad]
 *   quiz-tipo-[fuerza|cardio|ambos|inicio|energia|concentracion|
 *              memoria|calma|insomnio|estres|ansiedad|recuperacion|
 *              higado|intestino|inflamacion|general|tiroides|
 *              lento|definir|todo|cansancio|anemia|resfriados|corazon]
 *   quiz-genero-[hombre|mujer|neutral]
 */

(function () {
  'use strict';

  /* ── SVG helpers ──────────────────────────────────────────── */
  var ICO = {
    dumbbell:  '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="8.5" width="2.5" height="7" rx="1"/><rect x="4.5" y="10" width="2" height="4" rx=".5"/><line x1="6.5" y1="12" x2="17.5" y2="12"/><rect x="17.5" y="10" width="2" height="4" rx=".5"/><rect x="19.5" y="8.5" width="2.5" height="7" rx="1"/></svg>',
    activity:  '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>',
    lightning: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
    sprout:    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M7 20h10M10 20c5.5-2.5.8-6.4 3-10M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z"/><path d="M14.1 6a7 7 0 0 1 1.9 4.5c-1.5.5-3.1.4-4.5-.2.3-2.1.8-4 2.6-4.3z"/></svg>',
    brain:     '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96-.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3z"/><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96-.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3z"/></svg>',
    target:    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>',
    moon:      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9z"/></svg>',
    waves:     '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/></svg>',
    wind:      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2"/><path d="M9.6 4.6A2 2 0 1 1 11 8H2"/><path d="M12.6 19.4A2 2 0 1 0 14 16H2"/></svg>',
    heart:     '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
    droplet:   '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"/></svg>',
    leaf:      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>',
    flame:     '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>',
    sparkles:  '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3z"/><path d="M5 3v4M19 17v4M3 5h4M17 19h4"/></svg>',
    feather:   '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"/><line x1="16" y1="8" x2="2" y2="22"/><line x1="17.5" y1="15" x2="9" y2="15"/></svg>',
    clock:     '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
    scale:     '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1z"/><path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1z"/><path d="M7 21h10"/><path d="M12 3v18"/><path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"/></svg>',
    shield:    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>'
  };

  /* ── Todos los objetivos (para paso 2 dinámico) ───────────── */
  var OBJECTIVES = [
    { val: 'rendimiento', label: 'Rendimiento físico',  desc: 'Gym, fuerza, más músculo',        ico: ICO.dumbbell },
    { val: 'mental',      label: 'Mente y enfoque',     desc: 'Concentración, memoria, claridad', ico: ICO.brain    },
    { val: 'sueno',       label: 'Sueño y estrés',      desc: 'Dormir mejor, calmar la ansiedad', ico: ICO.moon     },
    { val: 'digestion',   label: 'Digestión y detox',   desc: 'Hígado, intestino, depurar',       ico: ICO.leaf     },
    { val: 'peso',        label: 'Peso y metabolismo',  desc: 'Quemar grasa, tiroides, definir',  ico: ICO.scale    },
    { val: 'inmunidad',   label: 'Inmunidad y salud',   desc: 'Defensas, energía, corazón',       ico: ICO.shield   }
  ];

  /* ── Contenido dinámico del Paso 4 ───────────────────────── */
  var Q4_DATA = {
    rendimiento: {
      eyebrow: 'Entrenamiento',
      title:   '¿Cómo describes tu entrenamiento?',
      sub:     'Ajustamos la recomendación a tu tipo de actividad.',
      opts: [
        { val: 'fuerza',  ico: ICO.dumbbell,  label: 'Pesas y fuerza',       desc: 'Quiero ganar músculo y levantar más' },
        { val: 'cardio',  ico: ICO.activity,  label: 'Cardio y resistencia',  desc: 'Corro, ciclo o hago HIIT' },
        { val: 'ambos',   ico: ICO.lightning, label: 'Potencia general',       desc: 'Mezclo fuerza con cardio' },
        { val: 'inicio',  ico: ICO.sprout,    label: 'Apenas inicio',          desc: 'Soy nuevo en el ejercicio' }
      ]
    },
    mental: {
      eyebrow: 'Desafío mental',
      title:   '¿Cuál es tu mayor reto mental?',
      sub:     'Identifica el síntoma que más te afecta.',
      opts: [
        { val: 'energia',       ico: ICO.lightning, label: 'Niebla mental y fatiga',   desc: 'Me siento lento o confundido' },
        { val: 'concentracion', ico: ICO.target,    label: 'Concentración y enfoque',  desc: 'Me cuesta mantenerme enfocado' },
        { val: 'memoria',       ico: ICO.brain,     label: 'Memoria y aprendizaje',    desc: 'Quiero retener mejor la info' },
        { val: 'calma',         ico: ICO.waves,     label: 'Calma con energía',        desc: 'Alerta sin ansiedad' }
      ]
    },
    sueno: {
      eyebrow: 'Problema principal',
      title:   '¿Qué te afecta más?',
      sub:     'Cuéntanos para ser más precisos.',
      opts: [
        { val: 'insomnio',     ico: ICO.moon,     label: 'Me cuesta dormir',      desc: 'Tardo en dormirme o me desvelo' },
        { val: 'estres',       ico: ICO.wind,     label: 'Estrés crónico',         desc: 'El día a día me tiene agotado' },
        { val: 'ansiedad',     ico: ICO.heart,    label: 'Ansiedad y nerviosismo', desc: 'Me siento ansioso frecuentemente' },
        { val: 'recuperacion', ico: ICO.dumbbell, label: 'Recuperación muscular',  desc: 'Amanezco adolorido tras entrenar' }
      ]
    },
    digestion: {
      eyebrow: 'Zona de malestar',
      title:   '¿Dónde sientes el mayor malestar?',
      sub:     'Así encontramos la solución exacta.',
      opts: [
        { val: 'higado',      ico: ICO.droplet,  label: 'Hígado y detox',       desc: 'Como pesado o consumo alcohol' },
        { val: 'intestino',   ico: ICO.leaf,     label: 'Intestino y tránsito',  desc: 'Bloating, estreñimiento o gases' },
        { val: 'inflamacion', ico: ICO.flame,    label: 'Inflamación general',   desc: 'Me siento inflamado frecuentemente' },
        { val: 'general',     ico: ICO.sparkles, label: 'Bienestar digestivo',   desc: 'Quiero optimizar mi salud intestinal' }
      ]
    },
    peso: {
      eyebrow: 'Situación actual',
      title:   '¿Cómo describes tu situación?',
      sub:     'Identificamos la causa raíz para recomendarte mejor.',
      opts: [
        { val: 'tiroides', ico: ICO.feather, label: 'Problemas de tiroides',  desc: 'Me dijeron que la tengo lenta' },
        { val: 'lento',    ico: ICO.clock,   label: 'Metabolismo lento',       desc: 'No bajo de peso aunque me cuido' },
        { val: 'definir',  ico: ICO.flame,   label: 'Quiero definirme',        desc: 'Tengo músculo pero quiero quemar grasa' },
        { val: 'todo',     ico: ICO.scale,   label: 'Control de peso general', desc: 'Quiero mantener un peso saludable' }
      ]
    },
    inmunidad: {
      eyebrow: 'Síntoma principal',
      title:   '¿Cuál síntoma te afecta más?',
      sub:     'Te recomendamos según tu necesidad específica.',
      opts: [
        { val: 'cansancio',  ico: ICO.moon,    label: 'Cansancio crónico',    desc: 'Siempre estoy agotado sin razón' },
        { val: 'anemia',     ico: ICO.droplet, label: 'Posible anemia',        desc: 'Me siento débil o con fatiga intensa' },
        { val: 'resfriados', ico: ICO.shield,  label: 'Me enfermo seguido',   desc: 'Mis defensas siempre están bajas' },
        { val: 'corazon',    ico: ICO.heart,   label: 'Salud cardiovascular',  desc: 'Quiero cuidar mi corazón y circulación' }
      ]
    }
  };

  /* ── Pesos de scoring ────────────────────────────────────── */
  var SCORE = { objetivo: 10, tipo: 6, genero: 3, neutral: 2 };

  /* ── Estado del quiz ─────────────────────────────────────── */
  var state = {
    current: 1,
    total:   4,
    answers: { q2: [] },
    result:  null
  };

  /* ── Referencias al DOM ──────────────────────────────────── */
  var el = {};

  /* ── Inicialización ──────────────────────────────────────── */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }
  }

  function setup() {
    el.pfill   = document.getElementById('pq-pfill');
    el.stepLbl = document.getElementById('pq-step-label');
    el.pct     = document.getElementById('pq-pct');
    el.btnBack = document.getElementById('pq-btn-back');
    el.btnNext = document.getElementById('pq-btn-next');
    el.nav     = document.getElementById('pq-nav');
    el.opts2   = document.getElementById('pq-opts2');
    el.opts4   = document.getElementById('pq-opts4');
    el.restart = document.getElementById('pq-restart');

    var resultCard = document.getElementById('pq-result-card');
    el.resultCardHTML = resultCard ? resultCard.innerHTML : '';

    if (!el.btnNext) return;

    el.btnNext.addEventListener('click', goNext);
    el.btnBack.addEventListener('click', goBack);
    el.restart && el.restart.addEventListener('click', restart);

    document.getElementById('pq-steps').addEventListener('click', function (e) {
      var opt = e.target.closest('.pq-opt');
      if (!opt) return;
      var group = opt.dataset.group;
      if (!group) return;
      pickOption(opt, group);
    });

    updateUI();
  }

  /* ── Seleccionar opción ──────────────────────────────────── */
  function pickOption(optEl, group) {
    /* Paso 2: multi-select (toggle) */
    if (state.current === 2) {
      optEl.classList.toggle('is-selected');
      var isSelected = optEl.classList.contains('is-selected');
      optEl.setAttribute('aria-checked', String(isSelected));

      if (!state.answers.q2) state.answers.q2 = [];
      var val = optEl.dataset.val;
      var idx = state.answers.q2.indexOf(val);
      if (isSelected && idx === -1) {
        state.answers.q2.push(val);
      } else if (!isSelected && idx > -1) {
        state.answers.q2.splice(idx, 1);
      }
      return;
    }

    /* Pasos 1, 3, 4: selección única */
    var container = document.getElementById('pq-' + group);
    if (container) {
      container.querySelectorAll('.pq-opt').forEach(function (o) {
        o.classList.remove('is-selected');
        o.setAttribute('aria-checked', 'false');
      });
    }

    optEl.classList.add('is-selected');
    optEl.setAttribute('aria-checked', 'true');

    state.answers['q' + state.current] = optEl.dataset.val;

    if (state.current === 1) {
      buildQ2(optEl.dataset.val);
      buildQ4(optEl.dataset.val);
    }

    el.btnNext.disabled = false;
  }

  /* ── Construir opciones del Paso 2 (objetivos adicionales) ── */
  function buildQ2(primaryObjective) {
    if (!el.opts2) return;

    var items = OBJECTIVES.filter(function (o) { return o.val !== primaryObjective; });

    el.opts2.innerHTML = items.map(function (o) {
      var selected = (state.answers.q2 || []).indexOf(o.val) > -1;
      return (
        '<div class="pq-opt' + (selected ? ' is-selected' : '') + '" ' +
        'data-val="' + o.val + '" data-group="opts2" ' +
        'role="checkbox" aria-checked="' + selected + '" tabindex="0">' +
        '<span class="pq-opt-ico">' + o.ico + '</span>' +
        '<div class="pq-opt-body">' +
        '<b class="pq-opt-label">' + escHtml(o.label) + '</b>' +
        '<span class="pq-opt-desc">' + escHtml(o.desc) + '</span>' +
        '</div></div>'
      );
    }).join('');
  }

  /* ── Construir opciones del Paso 4 (detalle dinámico) ────── */
  function buildQ4(goal) {
    var data = Q4_DATA[goal];
    if (!data) return;

    document.getElementById('pq-q4-eyebrow').textContent = data.eyebrow;
    document.getElementById('pq-q4-title').textContent   = data.title;
    document.getElementById('pq-q4-sub').textContent     = data.sub;

    if (!el.opts4) return;
    el.opts4.innerHTML = data.opts.map(function (o) {
      return (
        '<div class="pq-opt" data-val="' + o.val + '" data-group="opts4" ' +
        'role="radio" aria-checked="false" tabindex="0">' +
        '<span class="pq-opt-ico">' + o.ico + '</span>' +
        '<div class="pq-opt-body">' +
        '<b class="pq-opt-label">' + escHtml(o.label) + '</b>' +
        '<span class="pq-opt-desc">' + escHtml(o.desc) + '</span>' +
        '</div></div>'
      );
    }).join('');

    if (state.answers.q4) {
      var prev = el.opts4.querySelector('[data-val="' + state.answers.q4 + '"]');
      if (prev) prev.classList.add('is-selected');
    }
  }

  /* ── Siguiente paso ──────────────────────────────────────── */
  function goNext() {
    if (el.btnNext.disabled) return;

    var currentStep = document.querySelector('.pq-step.is-active');
    if (!currentStep) return;
    currentStep.classList.remove('is-active');

    state.current++;

    if (state.current > state.total) {
      showLoader();
    } else {
      var nextStep = document.querySelector('[data-step="' + state.current + '"]');
      if (nextStep) nextStep.classList.add('is-active');
      updateUI();
    }
  }

  /* ── Paso anterior ───────────────────────────────────────── */
  function goBack() {
    if (state.current <= 1) return;

    var currentStep = document.querySelector('.pq-step.is-active');
    if (!currentStep) return;
    currentStep.classList.remove('is-active');

    state.current--;

    var prevStep = document.querySelector('[data-step="' + state.current + '"]');
    if (prevStep) prevStep.classList.add('is-active');

    if (el.nav) el.nav.style.display = 'flex';
    updateUI();
  }

  /* ── Actualizar UI de progreso y nav ─────────────────────── */
  function updateUI() {
    var pct = Math.round(((state.current - 1) / state.total) * 100);

    if (el.pfill)   el.pfill.style.width = pct + '%';
    if (el.pct)     el.pct.textContent   = pct + '%';

    if (el.stepLbl && window.PQ_CONFIG) {
      el.stepLbl.textContent = PQ_CONFIG.stepLabel
        .replace('[N]', state.current)
        .replace('[T]', state.total);
    }

    if (el.btnBack) {
      el.btnBack.style.visibility = state.current > 1 ? 'visible' : 'hidden';
    }

    if (el.btnNext) {
      /* Paso 2 (multi-select) siempre habilitado — es opcional */
      if (state.current === 2) {
        el.btnNext.disabled = false;
      } else {
        el.btnNext.disabled = !state.answers['q' + state.current];
      }
    }

    updateDots(state.current, false);
  }

  /* ── Actualizar dots de pasos ────────────────────────────── */
  function updateDots(current, allDone) {
    document.querySelectorAll('.pq-dot').forEach(function (dot) {
      var n = parseInt(dot.dataset.dot, 10);
      dot.classList.remove('is-done', 'is-current');
      if (allDone) {
        dot.classList.add('is-done');
      } else if (n < current) {
        dot.classList.add('is-done');
      } else if (n === current) {
        dot.classList.add('is-current');
      }
    });
  }

  /* ── Mostrar pantalla de loader / descuento ──────────────── */
  function showLoader() {
    if (el.nav) el.nav.style.display = 'none';

    if (el.pfill)   el.pfill.style.width = '100%';
    if (el.pct)     el.pct.textContent   = '100%';
    if (el.stepLbl) el.stepLbl.textContent = '¡Listo!';
    updateDots(0, true);

    var loaderStep = document.querySelector('[data-step="loader"]');
    if (loaderStep) loaderStep.classList.add('is-active');

    setupCopyButton();
  }

  /* ── Lógica del botón copiar y desbloqueo ────────────────── */
  function setupCopyButton() {
    var copyBtn      = document.getElementById('pq-copy-btn');
    var seeResultBtn = document.getElementById('pq-see-results');
    var hintEl       = document.getElementById('pq-copy-hint');

    if (!copyBtn || !seeResultBtn) return;

    copyBtn.addEventListener('click', function () {
      copyToClipboard('QUIZ10', function () {
        var textEl = copyBtn.querySelector('.pq-copy-btn-text');
        if (textEl) textEl.textContent = '¡Copiado!';
        copyBtn.classList.add('pq-copy-btn--copied');
        copyBtn.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
          '<span class="pq-copy-btn-text">¡Copiado!</span>';
        if (hintEl) {
          hintEl.textContent = '¡Perfecto! Ahora puedes ver tus resultados.';
          hintEl.classList.add('pq-copy-hint--done');
        }
        seeResultBtn.disabled = false;
      });
    });

    seeResultBtn.addEventListener('click', function () {
      var loaderStep = document.querySelector('[data-step="loader"]');
      if (loaderStep) loaderStep.classList.remove('is-active');
      showResult();
    });
  }

  /* ── Copiar al portapapeles (con fallback) ───────────────── */
  function copyToClipboard(text, callback) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(callback).catch(function () {
        legacyCopy(text, callback);
      });
    } else {
      legacyCopy(text, callback);
    }
  }

  function legacyCopy(text, callback) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
    callback();
  }

  /* ── Calcular producto recomendado ───────────────────────── */
  function recommendProduct(objective, gender, tipo) {
    return recommendProductForObjective(objective, gender, tipo, null);
  }

  function recommendProductForObjective(objective, gender, tipo, excludeIds) {
    var products = window.PQ_PRODUCTS || [];
    if (!products.length) return null;

    var best      = null;
    var bestScore = -1;

    products.forEach(function (p) {
      if (!p.available) return;
      if (excludeIds && excludeIds[p.id]) return;

      var tags = (p.tags || '').split(',').map(function (t) {
        return t.trim().toLowerCase();
      });

      var score = 0;

      if (tags.indexOf('quiz-objetivo-' + objective) > -1) score += SCORE.objetivo;

      if (tipo && tags.indexOf('quiz-tipo-' + tipo) > -1) score += SCORE.tipo;

      var genderTag = 'quiz-genero-' + gender;
      if (tags.indexOf(genderTag) > -1) {
        score += SCORE.genero;
      } else if (tags.indexOf('quiz-genero-neutral') > -1) {
        score += SCORE.neutral;
      }

      if (score > bestScore) {
        bestScore = score;
        best      = p;
      }
    });

    return bestScore >= SCORE.objetivo ? best : null;
  }

  /* ── Mostrar resultado ───────────────────────────────────── */
  function showResult() {
    var q1 = state.answers.q1;
    var q2 = state.answers.q2 || [];
    var q3 = state.answers.q3;
    var q4 = state.answers.q4;

    state.result = recommendProduct(q1, q3, q4);

    var resultStep = document.querySelector('[data-step="result"]');
    if (resultStep) resultStep.classList.add('is-active');

    if (!state.result) {
      renderNoResult();
    } else {
      renderProduct(state.result);
    }

    /* Bundle de objetivos adicionales */
    if (q2.length > 0) {
      renderBundle(q2, q3);
    }
  }

  /* ── Renderizar producto principal ───────────────────────── */
  function renderProduct(p) {
    var cfg = window.PQ_CONFIG || {};

    if (cfg.showImage) {
      var imgWrap = document.getElementById('pq-result-img');
      var img     = document.getElementById('pq-img');
      if (imgWrap && img) {
        if (p.image) {
          img.src = p.image;
          img.alt = p.title;
          imgWrap.removeAttribute('data-empty');
        } else {
          imgWrap.setAttribute('data-empty', 'true');
        }
      }
    }

    setText('pq-brand', p.vendor || '');
    setText('pq-name',  p.title  || '');
    setText('pq-desc',  p.description || '');
    setText('pq-price', p.price || '');

    var howText = getTagValue(p.tags, 'quiz-uso') || '';
    var howWrap = document.getElementById('pq-how-wrap');
    if (howWrap) {
      if (howText) {
        document.getElementById('pq-how').textContent = howText;
      } else {
        howWrap.style.display = 'none';
      }
    }

    renderReasons(getTagValues(p.tags, 'quiz-razon'));

    if (cfg.showSku) {
      var skuEl = document.getElementById('pq-sku');
      var sku   = getTagValue(p.tags, 'sku') || p.handle || '';
      if (skuEl) skuEl.textContent = sku ? 'SKU: ' + sku : '';
    }

    var btnView = document.getElementById('pq-btn-view');
    if (btnView) btnView.href = p.url || '#';

    var btnCart = document.getElementById('pq-btn-cart');
    if (btnCart && p.variantId) {
      btnCart.dataset.variantId = p.variantId;
      btnCart.addEventListener('click', handleAddToCart);
    }
  }

  /* ── Renderizar bundle de objetivos adicionales ──────────── */
  function renderBundle(secondaryObjectives, gender) {
    var bundleSection = document.getElementById('pq-bundle-section');
    var bundleGrid    = document.getElementById('pq-bundle-grid');
    if (!bundleSection || !bundleGrid) return;

    /* Excluir producto principal y duplicados */
    var excludeIds = {};
    if (state.result) excludeIds[state.result.id] = true;

    var bundleItems = [];
    secondaryObjectives.forEach(function (obj) {
      var p = recommendProductForObjective(obj, gender, null, excludeIds);
      if (p) {
        bundleItems.push(p);
        excludeIds[p.id] = true;
      }
    });

    if (!bundleItems.length) return;

    var cfg = window.PQ_CONFIG || {};

    bundleGrid.innerHTML = bundleItems.map(function (p) {
      var imgHtml = '';
      if (cfg.showImage && p.image) {
        imgHtml = '<div class="pq-bundle-img"><img src="' + escHtml(p.image) + '" alt="' + escHtml(p.title) + '" loading="lazy"></div>';
      }
      return (
        '<div class="pq-bundle-item">' +
        imgHtml +
        '<div class="pq-bundle-info">' +
        '<p class="pq-bundle-brand">' + escHtml(p.vendor || '') + '</p>' +
        '<p class="pq-bundle-name">'  + escHtml(p.title)        + '</p>' +
        '<p class="pq-bundle-price">' + escHtml(p.price || '')  + '</p>' +
        '</div>' +
        '<div class="pq-bundle-actions">' +
        '<a class="pq-btn pq-btn--secondary pq-btn--sm" href="' + escHtml(p.url || '#') + '">Ver</a>' +
        '<button class="pq-btn pq-btn--primary pq-btn--sm pq-bundle-cart-btn" data-variant-id="' + p.variantId + '">' +
        '<span class="pq-btn-text">Agregar</span>' +
        '<span class="pq-btn-loader" aria-hidden="true"></span>' +
        '</button>' +
        '</div>' +
        '</div>'
      );
    }).join('');

    bundleSection.style.display = 'block';

    bundleGrid.querySelectorAll('.pq-bundle-cart-btn').forEach(function (btn) {
      btn.addEventListener('click', handleAddToCart);
    });
  }

  /* ── Renderizar sin resultado ────────────────────────────── */
  function renderNoResult() {
    var card = document.getElementById('pq-result-card');
    if (!card) return;
    var msg = (window.PQ_CONFIG && PQ_CONFIG.noResultMsg) || 'No encontramos un resultado exacto.';
    card.innerHTML = '<div class="pq-no-result"><p>' + escHtml(msg) + '</p></div>';
  }

  /* ── Renderizar razones ──────────────────────────────────── */
  function renderReasons(reasons) {
    var container = document.getElementById('pq-reasons');
    if (!container) return;

    if (!reasons || !reasons.length) {
      container.style.display = 'none';
      return;
    }

    var checkSvg = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">' +
      '<polyline points="2,5.5 4,7.5 8,3" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';

    container.innerHTML = reasons.map(function (r) {
      return (
        '<li>' +
        '<span class="pq-reason-check" style="color:var(--pq-accent)">' + checkSvg + '</span>' +
        escHtml(r) +
        '</li>'
      );
    }).join('');
  }

  /* ── Agregar al carrito (Shopify Cart API) ───────────────── */
  function handleAddToCart(e) {
    var btn       = e.currentTarget;
    var variantId = parseInt(btn.dataset.variantId, 10);
    var cfg       = window.PQ_CONFIG || {};

    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    btn.classList.add('pq-btn--loading');

    fetch('/cart/add.js', {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept':       'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart error ' + res.status);
      return res.json();
    })
    .then(function () {
      btn.classList.remove('pq-btn--loading');
      var textEl = btn.querySelector('.pq-btn-text');
      if (textEl) textEl.textContent = cfg.addedText || '¡Agregado! ✓';
      btn.style.background = '#059669';
      refreshCart();
    })
    .catch(function (err) {
      console.error('[ProductQuiz] Cart error:', err);
      btn.classList.remove('pq-btn--loading');
      btn.disabled = false;
      var textEl = btn.querySelector('.pq-btn-text');
      if (textEl) textEl.textContent = cfg.errorText || 'Error. Intenta de nuevo.';
      btn.style.borderColor = '#ef4444';
    });
  }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { open: true }
    }));
  }

  /* ── Reiniciar quiz ──────────────────────────────────────── */
  function restart() {
    state.current = 1;
    state.answers = { q2: [] };
    state.result  = null;

    document.querySelectorAll('.pq-opt.is-selected').forEach(function (o) {
      o.classList.remove('is-selected');
      o.setAttribute('aria-checked', 'false');
    });

    document.querySelectorAll('.pq-step').forEach(function (s) {
      s.classList.remove('is-active');
    });

    /* Ocultar bundle */
    var bundleSection = document.getElementById('pq-bundle-section');
    if (bundleSection) bundleSection.style.display = 'none';

    /* Restaurar loader */
    var copyBtn = document.getElementById('pq-copy-btn');
    if (copyBtn) {
      copyBtn.classList.remove('pq-copy-btn--copied');
      copyBtn.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>' +
        '<span class="pq-copy-btn-text">Copiar código</span>';
    }
    var seeResultsBtn = document.getElementById('pq-see-results');
    if (seeResultsBtn) seeResultsBtn.disabled = true;
    var hintEl = document.getElementById('pq-copy-hint');
    if (hintEl) {
      hintEl.textContent = 'Copia el código para desbloquear tus resultados';
      hintEl.classList.remove('pq-copy-hint--done');
    }

    var first = document.querySelector('[data-step="1"]');
    if (first) first.classList.add('is-active');

    if (el.nav) el.nav.style.display = 'flex';
    if (el.btnNext) el.btnNext.disabled = true;

    updateDots(1, false);

    var resultCard = document.getElementById('pq-result-card');
    if (resultCard && el.resultCardHTML !== undefined) {
      resultCard.innerHTML = el.resultCardHTML;
    }

    updateUI();
  }

  /* ── Utilidades ──────────────────────────────────────────── */
  function setText(id, value) {
    var node = document.getElementById(id);
    if (node) node.textContent = value;
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getTagValue(tagsStr, prefix) {
    var tags = (tagsStr || '').split(',');
    for (var i = 0; i < tags.length; i++) {
      var t = tags[i].trim().toLowerCase();
      if (t.indexOf(prefix + '-') === 0) {
        return t.slice(prefix.length + 1).replace(/-/g, ' ');
      }
    }
    return '';
  }

  function getTagValues(tagsStr, prefix) {
    var tags   = (tagsStr || '').split(',');
    var result = [];
    tags.forEach(function (t) {
      t = t.trim().toLowerCase();
      if (t.indexOf(prefix + '-') === 0) {
        result.push(capitalizeFirst(t.slice(prefix.length + 1).replace(/-/g, ' ')));
      }
    });
    return result;
  }

  function capitalizeFirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  /* ── Arranque ────────────────────────────────────────────── */
  init();

})();
